import { isEmpty } from 'lodash'

/**
 * Monta a query string que leva o controle de origem para o fluxo de geração de documento modelo.
 * É por ela que a última etapa do fluxo sabe a qual evidência o documento gerado deve ser vinculado.
 */
const mountControlOriginSearch = ({
  governanceProjectId,
  activityId,
  evidenceId,
}) => {
  if (!governanceProjectId || !activityId || !evidenceId) return ''

  const searchParams = new URLSearchParams({
    governanceProjectId,
    activityId,
    evidenceId,
  })

  const search = searchParams.toString()

  return isEmpty(search) ? '' : `?${search}`
}

export default mountControlOriginSearch
